import { render, staticRenderFns } from "./bar-chart.vue?vue&type=template&id=425a782a&scoped=true"
import script from "./bar-chart.vue?vue&type=script&lang=js"
export * from "./bar-chart.vue?vue&type=script&lang=js"
import style0 from "./bar-chart.vue?vue&type=style&index=0&id=425a782a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425a782a",
  null
  
)

export default component.exports